import type { PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { EditUserFormBankAccountFieldValues } from '../schema';

type IGenerateRequest = (
  formValues: EditUserFormBankAccountFieldValues
) => PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody;

/**
 * 利用者編集フォーム（口座連携版）の値から PUT API リクエストボディを生成する
 *
 * @param formValues - フォームの入力値
 * @returns PUT /partner_admins/users/:userId のリクエストボディ
 */
export const generateRequest: IGenerateRequest = formValues => ({
  user: {
    full_name: formValues.fullName,
    email: formValues.email,
    external_user_id: formValues.externalUserId ?? '',
    ...(formValues.password ? { password: formValues.password } : {}),
    ...(formValues.password && formValues.passwordConfirmation
      ? { password_confirmation: formValues.passwordConfirmation }
      : {}),
    // billableFrom は Zod スキーマ（editUserFormBankAccountSchema）で必須バリデーション済みかつ
    // .transform で Date 型に絞り込み済みのため、null 分岐は不要で常に送信する。
    billable_from: formatDate({ date: formValues.billableFrom, formatType: 'yyyy-MM-dd' }),
  },
});
